import { usePartnerBranding } from "~/composables/usePartnerBranding"

/**
 * In partner (co-branded) mode the customer arrives already authenticated from
 * the partner (see `middleware/session.global.ts`), so Dapamas' own
 * login/registro flows must stay hidden. This guards against manual navigation
 * to any `/auth/*` route by redirecting back to the store.
 */
export default defineNuxtRouteMiddleware((to) => {
    const { isPartnerMode } = usePartnerBranding()

    if (isPartnerMode.value && to.path.toLowerCase().startsWith("/auth")) {
        return navigateTo("/store")
    }
})
